import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getWhyWeInvest } from 'src/app/home/adapters'
import { mapWhyWeInvestCompanies } from 'src/app/home/pages/why-we-invest/domain/use-cases/map-why-we-invest-company'
import type { ICompany } from 'src/app/home/pages/why-we-invest/types'
import { whyWeInvestKeys } from 'src/app/home/queries/keys'

export const useWhyWeInvestQuery = (): UseQueryResult<ICompany[], Error> =>
  useQuery({
    queryKey: whyWeInvestKeys.list(),
    meta: { silent: true },
    queryFn: async (): Promise<ICompany[]> => {
      const response = await getWhyWeInvest()
      return mapWhyWeInvestCompanies(response)
    },
  })
